import { Flex, Spinner } from '@chakra-ui/react';
import { jsx as _jsx } from "react/jsx-runtime";

var Loading = function Loading(_ref) {
  var _ref$minHeight = _ref.minHeight,
      minHeight = _ref$minHeight === void 0 ? 400 : _ref$minHeight;
  return /*#__PURE__*/_jsx(Flex, {
    w: "full",
    minHeight: minHeight,
    justify: "center",
    align: "center",
    e2eid: "common_Loading_Flex",
    children: /*#__PURE__*/_jsx(Spinner, {
      thickness: "4px",
      speed: "0.65s",
      emptyColor: "gray.200",
      color: "brand",
      size: "xl",
      e2eid: "common_Loading_Spinner"
    })
  });
};

export default Loading;